<script setup lang="ts">
import CarouselMobile from '../../../CarouselMobile/CarouselMobile.vue';
import IMG_MSG_NICK_NAME from '../../assets/msg-nick-name.png';
import IMG_STEP_NICK_NAME from '../../assets/step-nick-name.png';

interface Props {
  backgroundImage: string;
  productImage?: string;
  isMsgShow?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  productImage: '',
  isMsgShow: true
});
</script>

<template>
<div class="nick-name">
  <CarouselMobile
    :mobileFrameImage="IMG_STEP_NICK_NAME"
    :backgroundImage="props.backgroundImage"
    :productImage="props.productImage"
    :msgImage="IMG_MSG_NICK_NAME"
    :isMsgShow="props.isMsgShow"
    :isShowHeaderInfo="true"
  />
</div>
</template>
